import { apiClient } from './apiClient';
import { API_CONFIG } from '../config/api';
import { logError, logInfo } from './logtail';

export interface StripeCheckoutSession {
  success: boolean;
  sessionUrl?: string;
  errorMessage?: string;
}

export const createCheckoutSession = async (priceId: string): Promise<StripeCheckoutSession> => {
  try {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.STRIPE_CHECKOUT, {
      priceId
    });
    logInfo('Created Stripe checkout session', { priceId });
    return response.data;
  } catch (error) {
    logError('Failed to create checkout session', { priceId, error });
    throw error;
  }
};

export const createUpgradeSession = async (priceId: string): Promise<StripeCheckoutSession> => {
  try {
    const response = await apiClient.post('/stripe/create-upgrade-session', {
      priceId
    });
    logInfo('Created Stripe upgrade session', { priceId });
    return response.data;
  } catch (error) {
    logError('Failed to create upgrade session', { priceId, error });
    throw error;
  }
}; 